// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__U7PBa","icon":"SortAdornment_icon__1bUk1","up":"SortAdornment_up__2x966","down":"SortAdornment_down__3p_yu","active":"SortAdornment_active__i41Xf"};